import { useSelector } from 'react-redux';

import { Fleet } from '../interfaces';
import { selectFleet } from '../selectors/stateSelectors';

export const useFleet = (): Fleet => {
  const fleet = useSelector(selectFleet);
  return fleet;
};
